import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Landing } from '@/pages/Landing';
import { Dashboard } from '@/pages/Dashboard';
import { CreateEvent } from '@/pages/CreateEvent';
import { EditEvent } from '@/pages/EditEvent';
import { EventAdmin } from '@/pages/EventAdmin';
import { EventPage } from '@/pages/EventPage';
import { AuthCallback } from '@/pages/AuthCallback';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { ThemeProvider } from '@/components/ThemeProvider';

export function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/new"
          element={
            <ProtectedRoute>
              <CreateEvent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/:id/edit"
          element={
            <ProtectedRoute>
              <EditEvent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/:id/admin"
          element={
            <ProtectedRoute>
              <EventAdmin />
            </ProtectedRoute>
          }
        />
        <Route path="/:slug" element={<EventPage />} />
      </Routes>
    </ThemeProvider>
  );
}
